<template>
  <div>
    <page-table editPath="/main/course/group/schedule/edit" :data-api="this.api.coach.course" :params="params" :deletable="false">
      <el-table-column prop="id" label="编号">
      </el-table-column>
      <el-table-column prop="courseName" label="课程名称">
      </el-table-column>
      <el-table-column prop="startTime" label="上课时间" :formatter="timeFormat">
      </el-table-column>
      <el-table-column prop="reservation" label="预约人数" :formatter="function(row){return row.reserve+'/'+ row.personMax}">"}">
      </el-table-column>
    </page-table>
  </div>
</template>
<script>
import Moment from 'moment'

export default {
  data () {
    return {
    }
  },
  created: function () {
  },
  methods: {
    timeFormat (row, column, cellValue) {
      return Moment(row.scheduleDate).format('YYYY-MM-DD') + Moment(row.startTime).format(' HH:mm') + Moment(row.endTime).format('-HH:mm')
    }
  },
  computed: {
    params: function () {
      return { coachId: this.$route.params.id }
    }
  }
}
</script>



// WEBPACK FOOTER //
// course.vue?ca610b90